<template>
  <div>
    <h1 class="subheading grey--text mb-3">
      {{ $tc('common.Course', 1) }}
    </h1>
    <GenericLogTable
      ref="table"
      class="mb-5"
      :logs="logs"
      :logtypes="logtypes"
      :loading="loading"
      :components="components"
      @editLog="onEdit"
      :getSpecialLabel="getSpecialLabel"
      :requiredValidators="requiredValidators"
    />
    <v-dialog
      v-model="showDialog"
      :persistent="true"
      :fullscreen="isMobile"
      :max-width="expandDialog ? '80%' : 600"
      lazy>
      <EditForm
        :title="$tc('common.Course', 2)"
        :logtypes="logtypes"
        :allcomponents="components"
        :expandDialog.sync="expandDialog"
        :close="() => showDialog = false"
        :logToEdit="logToEdit"
        :submit-handler="submit"
        :style="isMobile ? 'min-height: 100vh;' : ''"
      />
    </v-dialog>
    <SlotDial>
      <v-btn fab dark small color="indigo" @click="showDialog = true; logToEdit = null">
        <v-icon>add</v-icon>
      </v-btn>
      <v-btn fab dark small color="error" @click="deleteSelected">
        <v-icon>delete</v-icon>
      </v-btn>
    </SlotDial>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import { Component, Option } from '@/models/Specialty'
import { TrainningLogbook } from '@/models/TrainningActivity'
import trainningActivityFetcher from '@/mixins/trainningActivityFetcher'
import SlotDial from '@/components/SlotDial'
import EditForm from '@/views/ScientificActivity/components/EditForm'
import GenericLogTable from '@/views/ScientificActivity/components/GenericLogTable'

export default {
  mixins: [trainningActivityFetcher],
  components: {
    SlotDial,
    EditForm,
    GenericLogTable
  },
  data() {
    return {
      showDialog: false,
      loadingComponents: true,
      loadingLogs: true,
      logToEdit: null,
      requiredValidators: {},
      expandDialog: false,
    }
  },
  computed: {
    ...mapGetters(['courses']),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    components() {
      return (
        Component.query()
          .withAllRecursive()
          .get() || []
      )
    },
    loading() {
      return this.loadingComponents || this.loadingLogs
    },
    logs() {
      return this.loading ? [] : this.courses
    },
    logtypes() {
      return TrainningLogbook.query().get()
    }
  },
  methods: {
    ...mapActions(['getCourses', 'deleteCourses', 'addCourse', 'updateCourse']),
    deleteSelected() {
      this.$refs.table.deleteSelected(this.deleteCourses)
    },
    onEdit(logId) {
      this.logToEdit = this.logs.find(l => l.id === logId)
      this.showDialog = true
    },
    getSpecialLabel(log, component) {
      return null
    },
    submit(log) {
      const action = this.logToEdit
        ? this.updateCourse
        : this.addCourse

      return action({ ...log })
    }
  },
  created() {
    this.fetchTrainningActivity().then(() => {
      this.loadingComponents = false
    })
    this.getCourses()
      .catch(err =>
        this.showErrorSnackbar(err.message || 'Something went wrong')
      )
      .finally(() => {
        this.loadingLogs = false
      })
  }
}
</script>
<style>
</style>